{
  "nav": {
    "stats": "Statistikk",
    "registerCatch": "Registrer fangst",
    "myCatches": "Mine fangster",
    "myFiskekort": "Mine fiskekort",
    "myBookings": "Mine bookinger",
    "profile": "Profil",
    "login": "Logg inn",
    "logout": "Logg ut",
    "admin": "Admin",
    "valdAdmin": "Vald-admin",
    "riverAdmin": "Elveadmin",
    "history": "Historikk",
    "buyFiskekort": "Kjøp fiskekort",
    "registerLink": "Opprett konto",
    "loggFiskedag": "Logg fiskedag",
    "contact": "Kontakt oss",
    "language": "Språk",
    "fiskeHer": "Fiske her",
    "sectionFishing": "Fisking",
    "sectionExplore": "Utforsk",
    "sectionAccount": "Min side",
    "sectionManagement": "Administrasjon",
    "sectionForOwners": "For eiere",
    "sellFiskekort": "Selg fiskekort",
    "riverOwnersAssoc": "Elveeierlag",
    "photoContest": "Fotokonkurranse",
    "adminPhotoContest": "Fotokonkurranse (admin)",
    "menu": "Meny",
    "openMenu": "Åpne meny",
    "closeMenu": "Lukk meny",
    "privacy": "Personvern",
    "rivers": "Elver og vald"
  },
  "stats": {
    "title": "Fangststatistikk",
    "filterYear": "År",
    "filterMonth": "Måned",
    "filterWeek": "Uke",
    "filterDay": "Dag",
    "totalCatches": "Antall fangster",
    "totalWeight": "Total vekt",
    "avgWeight": "Snittsvekt",
    "biggestFish": "Største fisk",
    "released": "Gjenutsatt",
    "recentCatches": "Siste fangster",
    "noData": "Ingen fangster i valgt periode",
    "allRivers": "Alle elver",
    "allValds": "Alle vald",
    "viewVald": "Se valdside →",
    "uniqueAnglers": "Fiskere",
    "cpue": "Fangst per fisker",
    "registerCatchDesc": "Registrer fisken du har tatt med art, vekt og lengde. Navnet ditt vises ikke offentlig som standard.",
    "startFishingDesc": "Trykk når du begynner å fiske, og «Ferdig fisket» når du er ferdig. Vi lagrer bare tidspunkt, aldri posisjon.",
    "intro": "Lakseborsen er en åpen <b>laksebørs</b> som samler <b>laksestatistikk</b> i sanntid fra registrerte norske lakse- og sjøørretelver. Se oppdaterte fangsttall for <b>{{year}}</b> — antall fangster, samlet vekt, snittvekt og største fisk per elv eller vald. Gå til <history>fangsthistorikk</history> for sesonger tilbake til 2014."
  },
  "catch": {
    "title": "Registrer fangst",
    "vald": "Vald",
    "selectVald": "Velg vald…",
    "fishType": "Fisketype",
    "weight": "Vekt (kg)",
    "weightKg": "Vekt (kg)",
    "length": "Lengde (cm)",
    "lengthCm": "Lengde (cm)",
    "date": "Dato",
    "time": "Klokkeslett",
    "gear": "Redskap",
    "photo": "Bilde (valgfritt)",
    "photoUploadFailed": "Bildeopplasting mislyktes",
    "released": "Gjenutsatt",
    "fromBoat": "Fra båt",
    "sex": "Kjønn (valgfritt)",
    "sexTypes": {
      "hann": "Hann",
      "hunn": "Hunn"
    },
    "seaLice": "Lakselus",
    "fisher": "Fisker",
    "roer": "Roer",
    "onBehalf": {
      "question": "Hvem er dette en fangst for?",
      "self": "Meg selv",
      "other": "En annen fisker",
      "fisherName": "Fiskerens navn",
      "fisherNamePlaceholder": "Skriv inn navn",
      "recent": "Sist brukt"
    },
    "conditions": "Forhold ved fangst",
    "airTemp": "Lufttemperatur",
    "precipitation": "Nedbør",
    "windSpeed": "Vindstyrke",
    "waterTemp": "Vanntemperatur",
    "waterFlow": "Vannføring",
    "nveStationSource": "Kilde: {{station}}",
    "weatherPending": "Værdata tilgjengelig om ca 5 dager",
    "submit": "Registrer",
    "submitting": "Lagrer…",
    "success": "Fangst registrert!",
    "offlineDraft": "Lagret lokalt — sendes automatisk når du er online",
    "fishTypes": {
      "laks": "Laks",
      "brunørret": "Brunørret",
      "sjøørret": "Sjøørret",
      "pukkellaks": "Pukkellaks",
      "oppdrettslaks": "Oppdrettslaks",
      "støing": "Støing",
      "røye": "Røye",
      "ørret": "Sjøørret"
    },
    "gearTypes": {
      "flue": "Flue",
      "wobbler": "Wobbler",
      "spinner": "Spinner",
      "sluk": "Sluk",
      "mark_orm": "Mark / orm",
      "rapala": "Rapala",
      "annet": "Annet"
    },
    "errors": {
      "valdRequired": "Velg et vald",
      "weightInvalid": "Vekt må være mellom 0.1 og 100 kg",
      "lengthInvalid": "Lengde må være mellom 5 og 250 cm",
      "dateRequired": "Oppgi dato og klokkeslett",
      "fisherNameRequired": "Skriv inn navnet på fiskeren"
    },
    "fishingDayPrompt": "Fisket i dag uten fangst?",
    "logFishingDay": "Logg fiskedag",
    "logFishingDayDone": "Fiskedag registrert ✓",
    "edit": "Rediger",
    "editTitle": "Rediger fangst",
    "editSave": "Lagre endringer",
    "editSaved": "Fangst oppdatert!",
    "locate": {
      "button": "Bruk posisjonen min",
      "locating": "Finner posisjon…",
      "found": "Fant nærmeste vald: {{vald}}",
      "unsupported": "Posisjon støttes ikke i denne nettleseren",
      "denied": "Du må gi tilgang til posisjon for å bruke denne funksjonen",
      "failed": "Kunne ikke hente posisjonen din",
      "noneFound": "Fant ingen vald i nærheten med posisjonsdata"
    },
    "photoPendingOffline": "Bildet lastes opp automatisk når du er online igjen",
    "photoChange": "Bytt bilde",
    "photoAdd": "Legg til bilde",
    "photoPreviewAlt": "Forhåndsvisning",
    "fishingDayOffline": "Lagret lokalt — logges automatisk når du er online",
    "showNamePublic": "Vis navnet mitt offentlig",
    "showNamePublicDesc": "Av som standard. Fangsten teller uansett i statistikken."
  },
  "bulk": {
    "title": "Registrer småfisk (bulk)",
    "intro": "Fanget mange småørret? Registrer alle på én gang i stedet for én og én.",
    "count": "Antall fisk",
    "countHint": "Registrerer {{count}} fisk",
    "allReleased": "Alle gjenutsatt",
    "optionalMeasurements": "Valgfrie mål (la stå tom om ukjent)",
    "avgWeight": "Snittsvekt (kg)",
    "avgLength": "Snittlengde (cm)",
    "lengthHint": "Typisk under 40 cm",
    "submit": "Registrer {{count}} fisk",
    "submitting": "Registrerer…",
    "success": "{{count}} fisk registrert!",
    "successDetail": "Fangstene er lagret og teller med i statistikken.",
    "registerMore": "Registrer mer",
    "backToForm": "Vanlig registrering",
    "bulkLink": "Registrert mange småørret? → Bulk-registrering",
    "errors": {
      "countInvalid": "Antall må være mellom 1 og 50"
    },
    "decreaseCount": "Minus",
    "increaseCount": "Pluss"
  },
  "myCatches": {
    "title": "Mine fangster",
    "empty": "Du har ikke registrert noen fangster ennå.",
    "registerFirst": "Registrer din første fangst",
    "exportCsv": "Last ned mine fangster",
    "exportError": "Klarte ikke å laste ned fangstene"
  },
  "profile": {
    "title": "Min profil",
    "displayName": "Navn",
    "language": "Språk",
    "save": "Lagre",
    "saved": "Lagret!",
    "security": "Sikkerhet",
    "passkey": "Passkey (biometrisk innlogging)",
    "passkeyDesc": "Logg inn raskt med fingeravtrykk, ansiktsgjenkjenning eller en sikkerhetsnøkkel.",
    "registerPasskey": "Registrer passkey",
    "addPasskey": "Legg til ny passkey",
    "passkeyDefaultLabel": "Passkey",
    "passkeyAdded": "Lagt til {{date}}",
    "deletePasskey": "Slett",
    "confirmDeletePasskey": "Slette passkey \"{{label}}\"?",
    "hideNamePublic": "Vis fangstene mine anonymt",
    "hideNamePublicDesc": "Navnet ditt skjules på offentlig statistikk. Fangstene teller fortsatt i statistikken.",
    "deleteAccount": "Slett konto",
    "deleteAccountDesc": "Sletter navn, e-post og annen personlig informasjon fra profilen din. Fangstene dine beholdes anonymisert, slik loven krever for fangstrapportering.",
    "confirmDeleteAccount": "Er du sikker på at du vil slette kontoen din? Dette kan ikke angres.",
    "privacy": "Personvern",
    "privacyDesc": "Last ned alle dataene vi har om deg. Se også personvernerklæringen.",
    "exportData": "Last ned mine data"
  },
  "common": {
    "loading": "Laster…",
    "noResults": "Ingen treff",
    "error": "Noe gikk galt",
    "retry": "Prøv igjen",
    "kg": "kg",
    "cm": "cm",
    "back": "Tilbake",
    "clear": "Fjern",
    "delete": "Slett",
    "save": "Lagre",
    "cancel": "Avbryt",
    "paymentMethods": "Vi aksepterer Vipps, kort (Visa/Mastercard) og MobilePay.",
    "previousMonth": "Forrige måned",
    "nextMonth": "Neste måned"
  },
  "auth": {
    "loginRequired": "Logg inn for å fortsette",
    "loginForCatch": "Logg inn for å registrere fangst",
    "loginForMyCatches": "Logg inn for å se dine fangster",
    "loginForProfile": "Logg inn for å se profilen din",
    "loginHint": "Du kan logge inn med Google, e-postlenke eller passord",
    "registerHint": "Ny bruker?",
    "registerLink": "Opprett konto"
  },
  "admin": {
    "title": "Admin — dashboard",
    "totalCatches": "Totalt fangster",
    "catchesThisYear": "Fangster i år",
    "totalFishers": "Aktive fiskere",
    "totalUsers": "Registrerte brukere",
    "tabCatches": "Fangster",
    "tabUsers": "Brukere",
    "dateFrom": "Fra dato",
    "dateTo": "Til dato",
    "allFishTypes": "Alle fisketyper",
    "allReleased": "Alle (gjenutsatt)",
    "keptOnly": "Kun beholdt",
    "releasedOnly": "Kun gjenutsatt",
    "applyFilters": "Filtrer",
    "resetFilters": "Nullstill",
    "catchCount": "{{count}} fangster",
    "exportCsv": "Last ned CSV",
    "deleteSelected": "Slett valgte ({{count}})",
    "confirmBulkDeleteCatches": "Slette {{count}} fangst(er)? Dette kan ikke angres.",
    "bulkDeleteDone": "{{count}} fangst(er) slettet.",
    "selectAllOnPage": "Velg alle på siden",
    "selectRow": "Velg rad",
    "fisher": "Fisker",
    "yes": "Ja",
    "no": "Nei",
    "prevPage": "Forrige",
    "nextPage": "Neste",
    "userName": "Navn",
    "userEmail": "E-post",
    "userRole": "Rolle",
    "userCatches": "Fangster",
    "registered": "Registrert",
    "role_fisher": "Fisker",
    "role_admin": "Admin",
    "promote": "Gjør admin",
    "demote": "Fjern admin",
    "tabValds": "Vald",
    "tabRivers": "Elver",
    "searchRiver": "Søk elv (navn, kommune, system)…",
    "edit": "Rediger",
    "riverName": "Navn",
    "riverSystem": "System",
    "riverMunicipalities": "Kommune",
    "riverSeason": "Sesong",
    "riverFlags": "Status",
    "riverMain": "Hovedelv",
    "riverClosed": "Midlertidig stengt",
    "riverRequiresDisinfection": "Krev desinfeksjon",
    "riverDescription": "Beskrivelse",
    "riverFishingRules": "Fiskeregler",
    "riverSeasonOpen": "Sesong åpner (MM-DD)",
    "riverSeasonClose": "Sesong stenger (MM-DD)",
    "riverNveId": "NVE stasjon-ID",
    "riverNveName": "NVE stasjonsnavn",
    "valdName": "Vald",
    "valdRiver": "Elv",
    "valdOwner": "Eier",
    "valdNoOwner": "Ingen eier",
    "assignOwner": "Tildel eier",
    "clearOwner": "Fjern eier",
    "searchUser": "Søk bruker (navn eller e-post)…",
    "searchVald": "Søk vald…",
    "search": "Søk",
    "select": "Velg",
    "filterRiver": "Filtrer på elv",
    "allRivers": "Alle elver",
    "searchUsers": "Søk på navn eller e-post…",
    "ownedValds": "Vald",
    "selectVald": "Velg vald…",
    "assignVald": "Tildel vald",
    "removeValdOwner": "Fjern eierskap",
    "role_river_admin": "Elveadmin",
    "promoteRiverAdmin": "Gjør elveadmin",
    "demoteRiverAdmin": "Fjern elveadmin",
    "selectRiver": "Velg elv…",
    "selectRiverSystem": "Velg vassdrag…",
    "makeRiverAdmin": "Gjør til elveadmin",
    "inviteOwner": "Inviter valdeier",
    "inviteHint": "Skriv inn e-postadressen til den fremtidige valdeieren.",
    "inviteEmailPlaceholder": "Eierens e-post",
    "sendInvite": "Send invitasjon",
    "inviteSentOk": "Invitasjon sendt til {{email}}",
    "inviteAssignedDirect": "{{email}} er allerede bruker og ble tildelt eierskap",
    "pendingInvite": "Venter på {{email}}"
  },
  "riverAdmin": {
    "title": "Elveadmin",
    "totalCatches": "Totalt fangster",
    "catchesThisYear": "Fangster i år",
    "allYears": "Alle år",
    "exportCsv": "Last ned Excel",
    "exportError": "Klarte ikke å laste ned Excel",
    "tabs": {
      "fangster": "Fangster",
      "valds": "Vald",
      "elver": "Elver",
      "meldinger": "Meldinger",
      "vilkar": "Vilkår",
      "rettelser": "Rettelser",
      "fisketrykk": "Fisketrykk",
      "elvekort": "Elvekort"
    },
    "rivers": {
      "title": "Sesong og stenging",
      "hint": "Sett sesongdatoer per elv. Midlertidig stenging vises for fiskere.",
      "seasonOpen": "Sesong åpner",
      "seasonClose": "Sesong stenger",
      "month": "Måned",
      "day": "Dag",
      "temporarilyClosed": "Midlertidig stengt",
      "temporarilyClosedHint": "Viser et 'Midlertidig stengt'-varsel på den offentlige elvesiden. Fiskere kan fortsatt registrere fangst og kjøpe fiskekort.",
      "requiresDisinfection": "Krever desinfisering",
      "requiresDisinfectionHint": "Fiskere må bekrefte desinfiseringsmetode ved fiskekort-kjøp",
      "save": "Lagre",
      "saved": "Lagret ✓",
      "description": "Beskrivelse (vises offentlig)",
      "descriptionPlaceholder": "Skriv en kort beskrivelse av elva…",
      "municipalities": "Kommune",
      "municipalitiesPlaceholder": "F.eks. Røyrvik, Namsskogan, Grong, Overhalla, Namsos",
      "municipalitiesHint": "Vises i SEO-metadata og på elvesiden. Kan kun endres av admin.",
      "fishingRules": "Fiskeregler (tekst, vises offentlig)",
      "fishingRulesPlaceholder": "Skriv inn regler, begrensninger og annen info fiskere trenger å vite…",
      "images": "Bilder (vises på elvesiden)",
      "addPhoto": "+ Legg til bilde",
      "stayGuide": "Slik bor du her (tekst, vises offentlig)",
      "stayGuidePlaceholder": "Tips til hvordan fiskere best kan bo: nærmeste tettsted, hva som er lurt å booke tidlig, spisesteder, utleie av utstyr…",
      "nearbyPlaces": "Hoteller og spisesteder i nærheten",
      "placeName": "Navn",
      "placeDistance": "Avstand, f.eks. «5 min fra Formofoss»",
      "placeDescription": "Kort beskrivelse",
      "addPlace": "+ Legg til sted",
      "seasonEvents": "Hva skjer i sesongen (arrangementer)",
      "eventTitle": "Tittel, f.eks. «Laksens dag»",
      "eventStart": "Startdato",
      "eventEnd": "Sluttdato (valgfri)",
      "eventDescription": "Kort beskrivelse",
      "addEvent": "+ Legg til arrangement",
      "placeLat": "Breddegrad (valgfritt)",
      "placeLon": "Lengdegrad (valgfritt)",
      "placeHighlight": "Tekst fra sponsoren (vises som sponset innhold)",
      "placeTags": "Tilbud",
      "placeSponsor": "Støtter elva (sponsor)",
      "placePick": "Anbefalt? Skriv hvorfor (vises som «Anbefalt av elveeierlaget»)",
      "placeLogo": "Logo (valgfritt)",
      "sponsorReport": "Sponsorrapport",
      "sponsorReportMonth": "Måned",
      "sponsorReportLinks": "Klikk på lenken",
      "sponsorReportMap": "Vis på kart",
      "sponsorReportCopy": "Kopier tekst",
      "sponsorReportCopied": "Kopiert",
      "sponsorReportHint": "Teller klikk på sponsorlenken og «Vis på kart». Ingen personopplysninger lagres.",
      "sponsorReportText": "{{name}}: i {{month}} ble lenken din klikket {{link}} ganger og «Vis på kart» brukt {{map}} ganger på laksebørsen.",
      "sub": {
        "season": "Sesong",
        "content": "Innhold",
        "nearby": "I nærheten",
        "sponsors": "Sponsorer"
      },
      "selectRiver": "Velg elv",
      "systemPlacesNote": "Gjelder alle elver i {{system}}. Legg til én gang, så vises stedet på alle elvene.",
      "sponsorReportEmpty": "Ingen sponsorer ennå. Under «I nærheten» kan du krysse av for «Støtter elva (sponsor)» på en oppføring. Sponsorene dukker da opp her med antall klikk per måned.",
      "placeFamily": "For hele familien (også de som ikke fisker)",
      "placePhone": "Telefon",
      "placeImage": "Bilde (sponsor)",
      "sponsorTier_none": "Ingen sponsor",
      "sponsorTier_friend": "Venn av elva",
      "sponsorTier_local": "Lokal støtte",
      "sponsorTier_supporter": "Støttespiller",
      "sponsorTier_partner": "Partner",
      "sponsorTier_main": "Hovedsponsor"
    },
    "valds": {
      "title": "Vald",
      "ownerLabel": "Eier",
      "noOwner": "Ingen eier",
      "assignOwner": "Endre eier",
      "clearOwner": "Fjern eier",
      "searchUsers": "Søk etter bruker (navn eller e-post)…"
    },
    "messaging": {
      "title": "Send melding",
      "recipients": "Mottakere",
      "recipientValdeiere": "Valdeiere",
      "recipientFishers": "Fiskere",
      "recipientAll": "Alle",
      "subject": "Emne",
      "body": "Melding",
      "send": "Send melding",
      "sending": "Sender…",
      "sent": "Sendt til {{count}} mottakere",
      "sentCount": "Antall sendt",
      "history": "Sendte meldinger",
      "empty": "Ingen meldinger sendt ennå",
      "recipientCustom": "Enkeltpersoner",
      "emailToggle": "Send også på e-post ({{count}} med e-post)",
      "previewCount": "{{count}} mottakere",
      "noRecipients": "Ingen mottakere funnet",
      "sendBtn": "Send til {{count}} mottakere"
    }
  },
  "notifications": {
    "title": "Varsler",
    "markAllRead": "Merk alle som lest",
    "empty": "Ingen varsler",
    "typeMessageReceived": "Ny melding",
    "typeValdOwnerAssigned": "Vald tildelt"
  },
  "valdPage": {
    "river": "Elv",
    "owner": "Eier",
    "noOwner": "Ikke tilgjengelig",
    "catchesThisYear": "Fangster i år",
    "fiskekortTitle": "Fiskekort",
    "noFiskekort": "Ingen fiskekort tilgjengelig for dette valdet",
    "loginToBook": "Logg inn for å kjøpe fiskekort",
    "buy": "Kjøp",
    "price": "Pris",
    "durationDay": "{{count}} dag",
    "durationDays": "{{count}} dager",
    "seasonLabel": "Sesong",
    "unlimited": "Ubegrenset",
    "available": "Ledige plasser",
    "remaining": "{{count}} ledige",
    "soldOut": "Utsolgt",
    "seasonOpens": "Sesong åpner {{date}}",
    "seasonEnded": "Sesongen er avsluttet",
    "preBook": "Forhåndsbestill",
    "packagesTitle": "Pakker",
    "noPackages": "Ingen pakker tilgjengelig",
    "packageIncludes": "Inkluderer",
    "combinedPrice": "Samlet pris: {{price}} kr",
    "orderPackageBtn": "Bestill pakke",
    "accommodationTitle": "Overnatting",
    "accommodationNoCardRequired": "Fiskekort ikke nødvendig – alle kan booke overnatting.",
    "noAccommodation": "Ingen overnattingstilbud tilgjengelig",
    "capacity": "{{count}} person",
    "capacity_plural": "{{count}} personer",
    "perNight": "/ natt",
    "book": "Book overnatting",
    "accommodationType_hytte": "Hytte",
    "accommodationType_rom": "Rom",
    "accommodationType_telt": "Teltplass",
    "accommodationType_campingvogn": "Camper/bobil",
    "accommodationType_annet": "Annet",
    "fishingSpotsTitle": "Fiskeplasser",
    "omOssTitle": "Om oss",
    "contactPhone": "Telefon",
    "contactEmail": "E-post",
    "contactWebsite": "Nettsted",
    "tilgjengelighet": "Tilgjengelighet",
    "avstandBilvei": "Avstand til bilvei",
    "editVald": "Rediger vald",
    "seePermits": "Se fiskekort"
  },
  "fiskekort": {
    "purchaseTitle": "Kjøp fiskekort",
    "product": "Produkt",
    "vald": "Vald",
    "validFrom": "Første dag",
    "validTo": "Gyldig til",
    "price": "Pris",
    "confirm": "Bekreft kjøp",
    "submitting": "Kjøper…",
    "success": "Fiskekort kjøpt!",
    "successDescription": "Kortet er nå aktivt. Du finner det under Mine fiskekort.",
    "viewMyCards": "Se mine fiskekort",
    "currency": "kr",
    "paymentProcessing": "Behandler betaling…",
    "paymentCancelled": "Betaling avbrutt",
    "paymentCancelledDesc": "Du kan prøve å kjøpe kortet på nytt.",
    "paymentPending": "Betaling registrert",
    "paymentPendingDesc": "Vi venter på bekreftelse fra betalingsleverandøren. Kortet ditt vises under Mine fiskekort når betalingen er bekreftet.",
    "seasonNote": "Sesong: {{open}} – {{close}}",
    "errorBeforeSeason": "Valgt dato er utenfor sesongen. Sesongen åpner {{open}}.",
    "errorAfterSeason": "Kortet strekker seg utover sesongslutt ({{close}}). Velg en tidligere startdato.",
    "disinfectionTitle": "Desinfisering (påkrevd)",
    "disinfectionHint": "Denne elva krever at du bekrefter at utstyr og/eller båt er desinfisert i henhold til regelverket (§ 25 lakse- og innlandsfiskloven).",
    "disinfectionRequired": "Du må velge desinfiseringsmetode.",
    "disinfectionMethod": {
      "dried_2weeks": "Tørket i minst 2 uker",
      "frozen": "Fryst",
      "heat_treated": "Varmebehandlet (minst 60 °C)",
      "chemical": "Kjemisk desinfisert"
    },
    "quantity": "Antall fiskekort",
    "totalPrice": "Total pris"
  },
  "myFiskekort": {
    "title": "Mine fiskekort",
    "empty": "Du har ingen fiskekort ennå.",
    "validFrom": "Fra",
    "validTo": "Til",
    "status": "Status",
    "status_confirmed": "Aktiv",
    "status_cancelled": "Kansellert",
    "status_pending": "Venter",
    "vald": "Vald",
    "product": "Type",
    "price": "Betalt",
    "bookAgain": "Book igjen →",
    "showProof": "Vis bevis",
    "registerCatch": "Registrer fangst"
  },
  "myBookings": {
    "title": "Mine bookinger",
    "empty": "Du har ingen bookinger ennå.",
    "listing": "Overnatting",
    "checkIn": "Innsjekk",
    "checkOut": "Utsjekk",
    "guests": "Gjester",
    "total": "Totalt",
    "status_confirmed": "Bekreftet",
    "status_cancelled": "Kansellert",
    "status_pending": "Venter",
    "cancelBtn": "Avbestill",
    "cancelConfirm": "Er du sikker på at du vil avbestille denne bookingen?",
    "cancelling": "Avbestiller…",
    "cancelError": "Kunne ikke avbestille. Prøv igjen.",
    "refundNote": "Bookingen er avbestilt. Eventuell refusjon behandles manuelt innen 5 virkedager."
  },
  "valdAdmin": {
    "title": "Vald-admin",
    "myValds": "Mine vald",
    "selectVald": "Velg et vald for å administrere",
    "searchVald": "Søk vald…",
    "catchesThisYear": "Fangster i år",
    "totalCatches": "Totalt fangster",
    "fiskekortTitle": "Fiskekort",
    "addProduct": "Legg til fiskekort",
    "editProduct": "Rediger",
    "deactivateProduct": "Deaktiver",
    "noProducts": "Ingen fiskekort konfigurert ennå",
    "description": "Beskrivelse (vises på offentlig valdside)",
    "savedDescription": "Lagret!",
    "saveDescription": "Lagre beskrivelse",
    "purchasesTitle": "Solgte fiskekort",
    "noPurchases": "Ingen salg registrert ennå",
    "productName": "Navn",
    "productPrice": "Pris (øre)",
    "productDuration": "Varighet (dager)",
    "productSeasonStart": "Sesong start (YYYY-MM-DD)",
    "productSeasonEnd": "Sesong slutt (YYYY-MM-DD)",
    "productQuota": "Kvote (blank = ubegrenset)",
    "save": "Lagre",
    "cancel": "Avbryt",
    "saving": "Lagrer…",
    "confirmDeactivate": "Deaktivere dette produktet?",
    "confirmForceDeleteProduct": "Produktet har bekreftede kjøp. Slette permanent (inkludert alle kjøp)? Dette kan ikke angres.",
    "purchaseFisher": "Fisker",
    "purchaseProduct": "Produkt",
    "purchaseValid": "Gyldig",
    "purchaseStatus": "Status",
    "purchasePaid": "Betalt",
    "backToValds": "Tilbake til vald-oversikt",
    "viewPublicPage": "Se offentlig side",
    "tabFiskekort": "Fiskekort",
    "tabAccommodation": "Overnatting",
    "tabPackages": "Pakker",
    "tabSettings": "Innstillinger",
    "tabRevenue": "Inntekter",
    "addListing": "Legg til overnatting",
    "editListing": "Rediger",
    "deactivateListing": "Deaktiver",
    "activateListing": "Aktiver",
    "managePhotos": "Bilder",
    "addPhoto": "Legg til bilde",
    "deletePhoto": "Slett bilde",
    "uploadingPhoto": "Laster opp...",
    "confirmDeletePhoto": "Slett dette bildet?",
    "noListings": "Ingen overnattingstilbud lagt til ennå",
    "listingName": "Navn",
    "listingType": "Type",
    "listingCapacity": "Kapasitet (antall personer)",
    "listingPrice": "Pris per natt (øre)",
    "listingDesc": "Beskrivelse",
    "listingProximityNote": "Avstand til fiskeplass",
    "listingProximityNotePlaceholder": "f.eks. 5 min kjøring fra Formofoss sone 2",
    "listingOpenFrom": "Åpen fra (MM-DD)",
    "listingOpenTo": "Åpen til (MM-DD)",
    "listingMinNights": "Min. netter",
    "listingMaxNights": "Maks. netter",
    "blockedPeriods": "Stengte perioder",
    "noBlockedPeriods": "Ingen stengte perioder.",
    "addBlockedPeriod": "Legg til steng",
    "blockedFrom": "Fra",
    "blockedTo": "Til",
    "blockedReason": "Årsak (valgfritt)",
    "blockedReasonHint": "f.eks. Vedlikehold",
    "bookingsTitle": "Bookingforespørsler for {{name}}",
    "noBookings": "Ingen bookingforespørsler",
    "bookingGuest": "Gjest",
    "bookingDates": "Datoer",
    "bookingStatus": "Status",
    "bookingConfirm": "Bekreft",
    "bookingCancel": "Avvis",
    "bookingStatus_pending": "Venter",
    "bookingStatus_confirmed": "Bekreftet",
    "bookingStatus_cancelled": "Avvist",
    "addPackage": "Legg til pakke",
    "editPackage": "Rediger",
    "deletePackage": "Slett",
    "noPackages": "Ingen pakker lagt til ennå",
    "packageName": "Navn",
    "packageDesc": "Beskrivelse",
    "packageFiskekort": "Fiskekort-produkt (valgfritt)",
    "packageAccommodation": "Overnatting (valgfritt)",
    "packageCombinedPrice": "Samlet pris i øre (valgfritt)",
    "packageNone": "— ingen —",
    "contactTitle": "Kontaktinfo (Om oss)",
    "contactName": "Navn / organisasjon",
    "contactPhone": "Telefon",
    "contactEmail": "E-post",
    "contactWebsite": "Nettsted",
    "saveContact": "Lagre kontaktinfo",
    "fishingOptionsTitle": "Fiskealternativer",
    "suitableForFlyFishing": "Egnet for fluefiske",
    "fishingFromBoat": "Fiske fra båt tilgjengelig",
    "saveFishingOptions": "Lagre fiskealternativer",
    "seasonPicker": {
      "yearRound": "Hele sesongen",
      "yearRoundNote": "Tilgjengelig hele året",
      "selectStart": "Klikk for å velge startdato",
      "selectEnd": "velg sluttdato"
    },
    "calendarPreview": "Vis kalenderforhåndsvisning",
    "calendarPreviewHide": "Skjul kalenderforhåndsvisning",
    "setupChecklist": {
      "title": "Kom i gang – sett opp valdet ditt",
      "step1": "Beskriv valdet",
      "step2": "Legg til fiskekort-produkt",
      "step3": "Legg til overnatting",
      "step4": "Opprett pakke",
      "optional": "valgfritt",
      "packageHint": "Opprett et fiskekort-produkt og en overnatting-listing først for å opprette en pakke."
    }
  },
  "history": {
    "title": "Fangsthistorikk",
    "year": "År",
    "week": "Uke",
    "weekLabel": "Uke {{week}}",
    "allWeeks": "Alle uker",
    "colTime": "Tid",
    "colFish": "Fisketype",
    "colWeight": "Vekt",
    "colLength": "Lengde",
    "colGear": "Redskap",
    "colVald": "Vald",
    "colFisher": "Fisker",
    "colReleased": "Gjenutsatt"
  },
  "accommodation": {
    "bookTitle": "Book overnatting",
    "listing": "Overnatting",
    "checkIn": "Innsjekk",
    "checkOut": "Utsjekk",
    "guestCount": "Antall gjester",
    "guestName": "Ditt navn",
    "guestEmail": "E-post",
    "guestPhone": "Telefon (valgfritt)",
    "notes": "Melding til eier (valgfritt)",
    "totalPrice": "Total pris",
    "totalNights": "{{count}} natt",
    "totalNights_plural": "{{count}} netter",
    "bookBtn": "Send bookingforespørsel",
    "submitting": "Sender…",
    "success": "Forespørsel sendt!",
    "successDetail": "Eieren vil kontakte deg for å bekrefte.",
    "loginRequired": "Du må logge inn for å booke overnatting",
    "perNight": "/ natt",
    "datesUnavailable": "Disse datoene er ikke tilgjengelige, velg andre datoer",
    "paymentProcessing": "Behandler betaling…",
    "paymentConfirmed": "Betaling bekreftet!",
    "paymentConfirmedDesc": "Overnattingen er bekreftet. Vi gleder oss til å se deg!",
    "paymentCancelled": "Betaling avbrutt",
    "paymentCancelledDesc": "Betalingen ble avbrutt. Du kan prøve igjen.",
    "paymentPending": "Betaling under behandling",
    "paymentPendingDesc": "Betalingen er ikke bekreftet ennå. Sjekk Mine bookinger om litt.",
    "viewMyBookings": "Se mine bookinger",
    "unavailablePeriods": "Opptatte perioder",
    "blockedPeriods": "Stengte perioder",
    "seasonWindow": "Sesongen er åpen {{from}} – {{to}}",
    "minNightsHint": "Minimum {{count}} netter",
    "maxNightsHint": "Maksimum {{count}} netter",
    "minNightsError": "Minst {{count}} netter kreves",
    "maxNightsError": "Maks {{count}} netter tillatt",
    "outsideSeason": "Valgte datoer er utenfor åpen sesong"
  },
  "fiskekortList": {
    "title": "Ledige fiskekort",
    "intro": "Velg fiskekort og kjøp direkte",
    "noProducts": "Ingen tilgjengelige fiskekort for øyeblikket",
    "buy": "Kjøp",
    "soldOut": "Utsolgt",
    "unlimited": "Ubegrenset",
    "remaining": "{{count}} igjen",
    "durationDay": "1 dag",
    "durationDays": "{{count}} dager",
    "calendarView": "Kalender",
    "listView": "Liste",
    "noProductsDay": "Ingen fiskekort tilgjengelig denne dagen",
    "legendAvailable": "Ledige",
    "legendSoldOut": "Utsolgt"
  },
  "fishingDay": {
    "title": "Logg fiskedag",
    "intro": "Registrer at du har fisket i dag uten å ha fanget noe.",
    "submit": "Logg fiskedag",
    "submitting": "Logger…",
    "success": "Fiskedag registrert!",
    "successCta": "Vil du registrere en fangst?",
    "calendarTitle": "Dine fiskedager",
    "noCatches": "ingen fangst",
    "catchCount_one": "{{count}} fangst",
    "catchCount_other": "{{count}} fangster",
    "delete": "Fjern",
    "confirmDelete": "Vil du fjerne denne fiskedagen?"
  },
  "contact": {
    "title": "Kontakt oss",
    "intro": "Har du spørsmål eller tilbakemeldinger? Send oss en melding, så svarer vi så fort vi kan.",
    "name": "Navn",
    "email": "E-postadresse",
    "message": "Melding",
    "send": "Send melding",
    "sending": "Sender...",
    "successMessage": "Takk! Vi har mottatt meldingen din og svarer deg snart.",
    "errorMessage": "Noe gikk galt. Prøv igjen eller send e-post direkte til noreply@lakseborsen.no."
  },
  "revenue": {
    "title": "Inntekter",
    "year": "År",
    "fiskekortTotal": "Fiskekort",
    "bookingsTotal": "Overnatting",
    "grandTotal": "Totalt",
    "fiskekortSales": "Solgte fiskekort",
    "accommodationBookings": "Overnattingsbookinger",
    "noData": "Ingen data for valgt år.",
    "exportCsv": "Last ned CSV",
    "product": "Produkt",
    "date": "Dato",
    "amount": "Beløp",
    "listing": "Objekt",
    "checkIn": "Innsjekk",
    "checkOut": "Utsjekk",
    "guest": "Gjest",
    "payoutStatus": "Utbetalt",
    "payoutDone": "Ja",
    "payoutPending": "Nei"
  },
  "packageOrder": {
    "title": "Bestill pakke",
    "priceBreakdown": "Prisoversikt",
    "fiskekortPart": "Fiskekort",
    "accommodationPart": "Overnatting",
    "combinedTotal": "Samlet pris",
    "validFrom": "Kortstart (innsjekk)",
    "checkIn": "Innsjekk",
    "checkOut": "Utsjekk",
    "guestCount": "Antall gjester",
    "guestName": "Ditt navn",
    "guestEmail": "E-post",
    "guestPhone": "Telefon (valgfritt)",
    "notes": "Melding (valgfritt)",
    "submitBtn": "Bestill og betal",
    "submitting": "Sender…",
    "paymentProcessing": "Behandler betaling…",
    "paymentConfirmed": "Pakke bestilt!",
    "paymentConfirmedDesc": "Fiskekort og overnatting er bekreftet. God fiske!",
    "paymentPending": "Betaling under behandling",
    "paymentPendingDesc": "Betalingen er ikke bekreftet ennå. Sjekk Mine bestillinger om litt.",
    "paymentCancelled": "Betaling avbrutt",
    "paymentCancelledDesc": "Du kan prøve igjen.",
    "viewMyBookings": "Se mine bookinger",
    "loginRequired": "Du må logge inn for å bestille pakke"
  },
  "riverPage": {
    "notFound": "Fant ikke elven",
    "temporarilyClosed": "Midlertidig stengt",
    "requiresDisinfection": "Desinfeksjon påkrevd",
    "packagesSection": "Pakker — fiskekort + overnatting",
    "valdsSection": "Vald og fiskekort",
    "accommodationSection": "Overnatting",
    "viewVald": "Se vald",
    "noValds": "Ingen vald registrert",
    "noProductsForVald": "Ingen kort tilgjengelig",
    "mapSection": "Kart over vassdraget",
    "fishingRulesTitle": "Fiskeregler",
    "eventsSection": "Hva skjer i sesongen",
    "staySection": "Bo, spis og opplev ved {{name}}",
    "readMore": "Les mer",
    "placeCategory_hotel": "Hotell",
    "placeCategory_restaurant": "Restaurant",
    "placeCategory_camping": "Camping",
    "placeCategory_cabin": "Hytter",
    "placeCategory_shop": "Butikk",
    "placeCategory_other": "Annet",
    "filterValds": "Søk etter vald…",
    "noValdMatch": "Ingen vald matcher søket",
    "fromPrice": "fra {{price}}",
    "cardCount_one": "{{count}} kort",
    "cardCount_other": "{{count}} kort",
    "noCardsAvailable": "Ingen kort tilgjengelig",
    "showAllValds": "Vis alle {{count}} vald",
    "seePermits": "Se fiskekort",
    "nearbyFilter_all": "Alle",
    "nearbyFilter_stay": "Overnatting",
    "nearbyFilter_eat": "Mat",
    "nearbyFilter_shop": "Butikker",
    "nearbyFilter_other": "Annet",
    "nearbyNear": "Nærmest",
    "nearbyNearNone": "Ingen valgt",
    "nearbyDistance": "{{km}} km i luftlinje fra {{vald}}",
    "nearbyBookable": "Kan bookes her",
    "nearbyAd": "Sponset innhold",
    "nearbyTag_fiskekort": "Selger fiskekort",
    "nearbyTag_tackle": "Fiskeutstyr",
    "nearbyTag_guide": "Guide",
    "nearbyTag_boat": "Båtutleie",
    "nearbyTag_drying": "Tørkerom",
    "nearbyTag_freezer": "Fryseboks",
    "nearbyTag_earlyBreakfast": "Tidlig frokost",
    "mapLayer_valds": "Vald",
    "mapLayer_spots": "Fiskeplasser",
    "nearbySponsor": "Støtter {{river}}",
    "nearbyPick": "Anbefalt av elveeierlaget",
    "nearbyShowOnMap": "Vis på kart",
    "sponsorsRow": "Støttet av",
    "placeCategory_attraction": "Severdigheter og opplevelser",
    "nearbyFilter_see": "Opplevelser",
    "nearbyFilter_family": "Familie",
    "nearbyFamily": "For hele familien",
    "nearbyVisit": "Besøk nettside",
    "nearbyCall": "Ring",
    "sponsorMain": "Hovedsponsor"
  },
  "fiskekortBevis": {
    "statusActive": "Aktiv — fiskekort gyldig",
    "refLabel": "Ref",
    "print": "Skriv ut / Del",
    "catchCtaText": "Har du fanget noe? Husk å registrere fangsten!",
    "catchCtaBtn": "Registrer fangst"
  },
  "discovery": {
    "title": "Finn fiskekort til norske lakseelver",
    "intro": "Utforsk vald og kjøp fiskekort fra valdeiere som selger via Lakseborsen. Filtrer etter elv, fisketeknikk eller tilgjengelighet.",
    "filterRiver": "Filtrer etter elv",
    "allRivers": "Alle elver",
    "flyFishing": "Fluefiske",
    "boatFishing": "Båtfiske",
    "hasFiskekort": "Fiskekort",
    "clearFilters": "Fjern filter",
    "resultCount": "{{count}} vald",
    "noResults": "Ingen vald matcher filteret.",
    "buyFiskekort": "Kjøp fiskekort",
    "seeVald": "Se vald",
    "searchPlaceholder": "Søk etter vald eller elv",
    "sortLabel": "Sorter",
    "sortName": "Navn (A-Å)",
    "sortPrice": "Pris"
  },
  "bliValdeier": {
    "title": "Bli valdeier",
    "lead": "Du er invitert til å bli valdeier for {{valdName}} på {{riverName}}.",
    "vald": "Vald",
    "river": "Elv",
    "loginHint": "Logg inn med kontoen registrert på invitert e-post for å akseptere.",
    "loginAndAccept": "Logg inn og aksepter",
    "autoClaimHint": "Fullfører registrering…",
    "claiming": "Registrerer eierskap…",
    "successTitle": "Velkommen som valdeier!",
    "successDesc": "Du er nå registrert som eier av {{valdName}}.",
    "goToValdAdmin": "Gå til vald-admin",
    "notFoundTitle": "Invitasjonen finnes ikke",
    "notFoundDesc": "Lenken er ugyldig eller utløpt.",
    "expiredTitle": "Invitasjonen er utløpt",
    "expiredDesc": "Be administratoren sende en ny invitasjon.",
    "claimedTitle": "Allerede brukt",
    "claimedDesc": "Denne invitasjonen er allerede akseptert.",
    "errorTitle": "Noe gikk galt"
  },
  "komIGang": {
    "selectVald": "Velg vald",
    "chooseVald": "Velg et vald",
    "step1Title": "Kontaktinformasjon",
    "step1Desc": "Legg inn kontaktdetaljer og en beskrivelse av valdet. Dette vises offentlig.",
    "contactName": "Kontaktperson",
    "contactNamePlaceholder": "Navn eller organisasjon",
    "phone": "Telefon",
    "email": "E-post",
    "website": "Nettside",
    "description": "Beskrivelse",
    "descriptionPlaceholder": "Fortell om valdet, fiskeforhold, regler osv.",
    "step2Title": "Kart og fiskemodaliteter",
    "step2Desc": "Plasser valdet på kartet, tegn grenser og velg fisketeknikker.",
    "mapLocation": "Kartposisjon (klikk for å plassere)",
    "polygon": "Valdgrense (valgfritt)",
    "flyFishing": "Egnet for fluefiske",
    "boatFishing": "Fiske fra båt mulig",
    "step3Title": "Fiskeplasser",
    "step3Desc": "Legg til spesifikke fiskeplasser på kartet (valgfritt).",
    "step3Hint": "Du kan legge til fiskeplasser fra vald-adminpanelet når som helst.",
    "back": "Tilbake",
    "nextStep": "Neste steg",
    "skipWizard": "Hopp over",
    "goToValdAdmin": "Gå til vald-admin"
  },
  "statsSection": {
    "title": "Statistikk og grafer",
    "yearLabel": "Sesong",
    "tooFewData": "Mer data trengs for å vise denne statistikken",
    "noCatchesForYear": "Ingen registrerte fangster i denne sesongen",
    "loading": "Laster statistikk…",
    "axisCatches": "Fangster",
    "axisAvgWeight": "Snittsvekt (kg)",
    "axisWeek": "Uke",
    "axisHour": "Time",
    "kpi": {
      "totalCatches": "Antall fangster",
      "totalWeight": "Total vekt",
      "avgWeight": "Snittsvekt",
      "biggestFish": "Største fisk",
      "releaseRate": "Andel gjenutsatt",
      "uniqueAnglers": "Aktive fiskere",
      "cpue": "Fangst per fisker",
      "fishingHours": "Fisketimer",
      "catchesPerHour": "Fangst per time",
      "anglersNow": "Fiskere nå"
    },
    "fishType": {
      "title": "Fordeling på fiskearter",
      "subtitle": "Antall fangster per art"
    },
    "gear": {
      "title": "Hvilket redskap fanger mest?",
      "subtitle": "Fangster fordelt på redskap"
    },
    "weekly": {
      "title": "Når på sesongen er fisket best?",
      "subtitle": "Fangster per uke"
    },
    "hour": {
      "title": "Når på dagen bites det?",
      "subtitle": "Fangster per klokketime"
    },
    "airTemp": {
      "title": "Lufttemperatur og fangst",
      "subtitle": "Antall fangster og snittsvekt per temperatur"
    },
    "waterTemp": {
      "title": "Vanntemperatur og fangst",
      "subtitle": "Antall fangster og snittsvekt per temperatur"
    },
    "waterFlow": {
      "title": "Vannføring og fangst",
      "subtitle": "Antall fangster og snittsvekt per vannføringsnivå"
    },
    "historicalHeader": "Historisk oversikt",
    "yearly": {
      "title": "Fangster per sesong",
      "subtitle": "Totalt antall registrerte fangster år for år"
    },
    "typical": {
      "title": "Typisk sesong vs. i år",
      "subtitle": "Snitt per uke basert på {{yearCount}} historiske sesonger",
      "avgLabel": "Snitt",
      "currentLabel": "{{year}}"
    },
    "biggest": {
      "title": "Største fangster gjennom tidene",
      "subtitle": "Topp 10 — klikk for å se fangsten"
    },
    "showAllCharts": "Vis alle grafer"
  },
  "installPrompt": {
    "text": "Legg til Lakseborsen på hjemskjermen for raskere tilgang",
    "iosHint": "Legg til Lakseborsen på hjemskjermen: åpne Del-menyen i nettleseren og velg «Legg til på Hjem-skjerm».",
    "install": "Legg til",
    "dismiss": "Lukk"
  },
  "textSize": {
    "label": "Tekststørrelse",
    "normal": "Normal tekststørrelse",
    "large": "Stor tekststørrelse",
    "xlarge": "Ekstra stor tekststørrelse"
  },
  "notFound": {
    "title": "Siden finnes ikke",
    "message": "Vi fant ikke siden du lette etter.",
    "backHome": "Til forsiden"
  },
  "terms": {
    "title": "Vilkår for fiske",
    "accept": "Jeg har lest og godtar vilkårene",
    "mustAccept": "Du må godta vilkårene for å fortsette.",
    "translationNote": "Dette er en oversettelse. Ved uenighet gjelder den norske teksten.",
    "noticeTitle": "Vilkår for fiske i vassdraget",
    "noticeBody": "Det er lagt inn vilkår for fiske i dette vassdraget, og du har ikke godtatt dem ennå. Det gjelder uansett hvor du har kjøpt fiskekort. Du kan fortsatt registrere fangsten din.",
    "readAndAccept": "Les og godta vilkårene",
    "acceptNow": "Jeg godtar vilkårene",
    "acceptFailed": "Kunne ikke lagre godkjenningen. Prøv igjen."
  },
  "checkin": {
    "intro": "Fisker du nå? Start fisking, så ser elveeierlaget hvor mye fisketid som ligger bak fangstene.",
    "start": "Start fisking nå",
    "end": "Ferdig fisket",
    "active": "Du fisker på {{vald}}",
    "endFailed": "kunne ikke avslutte",
    "pickVald": "Velg vald under først.",
    "privacy": "Vi lagrer bare tidspunkt, ikke posisjon.",
    "sessions": {
      "title": "Dine økter",
      "intro": "Glemte du å trykke «Start fisking» eller «Ferdig fisket»? Legg inn eller rett økten her. Tidene er egenrapporterte, og du kan legge inn økter fra de siste 60 dagene (høyst 14 timer per økt).",
      "empty": "Ingen økter ennå.",
      "add": "Legg til økt",
      "edit": "Rediger",
      "delete": "Slett",
      "confirmDelete": "Slette denne økten?",
      "vald": "Vald",
      "start": "Start",
      "end": "Slutt",
      "save": "Lagre",
      "cancel": "Avbryt",
      "running": "Pågår",
      "unknown": "Varighet ukjent: rett økten",
      "manual": "lagt inn manuelt",
      "hm": "{{h}} t {{m}} min",
      "errors": {
        "end_before_start": "Slutt må være etter start.",
        "too_long": "En økt kan være høyst 14 timer.",
        "in_future": "Tidspunktet kan ikke være i fremtiden.",
        "too_old": "Du kan bare legge inn økter fra de siste 60 dagene.",
        "overlap": "Økten overlapper en annen økt du har.",
        "open_session": "Avslutt økten med «Ferdig fisket» i stedet.",
        "end_required": "Legg inn når økten sluttet.",
        "vald_not_found": "Fant ikke valdet.",
        "generic": "Kunne ikke lagre økten. Prøv igjen."
      }
    }
  },
  "elvekort": {
    "notFound": "Fant ikke elvekortet.",
    "voluntary": "Elvekort er frivillig. Du trenger det ikke for å kjøpe fiskekort eller registrere fangst.",
    "buy": "Kjøp elvekort",
    "validPeriod": "Gyldig {{from}} – {{to}}",
    "myCards": "Mine elvekort",
    "offerTitle": "Elvekort for vassdraget",
    "confirmedTitle": "Elvekortet er kjøpt",
    "cancelledTitle": "Betalingen ble avbrutt",
    "processing": "Behandler betalingen…",
    "pendingHint": "Betalingen er ikke bekreftet ennå. Sjekk «Mine elvekort» om litt."
  },
  "riversPage": {
    "metaTitle": "Elver og vald – lakseelver i Norge | Lakseborsen",
    "metaDescription": "Oversikt over lakseelver og vald med fiskekort, sesong og overnatting.",
    "title": "Elver og vald",
    "intro": "Alle elvene på Lakseborsen med valdene i hver elv. Velg en elv for sesong, fiskeregler, overnatting og steder å spise i nærheten.",
    "closed": "Midlertidig stengt",
    "valds": "Vald",
    "seeRiver": "Se {{river}}",
    "aboutRiver": "Om elva",
    "valdsCount": "{{count}} vald"
  }
}
